<template>
  
  <div style="width:770px;marin:0 auto;margin-top:10px;margin-left:10px;">

    
            <el-form ref="form" :model="form" label-width="120px" v-loading="loading" :rules="rules">
            
            <table class="table table-bordered myTable ">
             
                <tr>

                  <td  colspan="2">
                    <div class="d-flex align-items-center">
                      <el-form-item label="상위선택"  class="mb-0 formItem">
                      <el-select v-model="form.boss" :placeholder="$t('searchText.타이틀선택')" size="mini" prop="boss" filterable>
                       <el-option
                              v-for="item in zplist"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                      </el-select>
                    </el-form-item>
                  <span class="ml-1">카지노롤링:{{ this.boss_event_loing_recom_e }} 슬롯롤링:{{ this.boss_event_loing_recom_slot }}</span></div>
                  </td>
                
                </tr>
                 <tr>
                 
                  <td width="50%">
                      
                 

                        <el-form-item :label="$t('nav.아이디')"  prop="mem_id" class="mb-0 formItem">
                      <el-input v-model="form.mem_id" class="mr-1 w-50" ></el-input>
                        <el-button type="primary" size="mini" plain @click="reConfirm" :loading="reLoading">{{$t('msg.확인')}}</el-button>
                      
                    </el-form-item>
                  </td>
                   <td>
                       <el-form-item :label="$t('msg.닉네임')" prop="mem_name" class="mb-0 formItem">
                          <el-input v-model="form.mem_name"></el-input>
                        </el-form-item>
                   
                  </td>
                </tr>
                 <tr>
                  <td>
                    <el-form-item :label="$t('tableText.사용자암호')" :prop="editIndex===-1 ? 'mem_pw' :'empty'" class="mb-0 formItem">
                      <el-input v-model="form.mem_pw"></el-input>
                    </el-form-item>
                    
                  </td>
                  <td>
                       <el-form-item :label="$t('msg.핸드폰')" class="mb-0 formItem">
                          <el-input v-model="form.mem_hp"></el-input>
                        </el-form-item>
                  
                  </td>
                </tr>
                 <tr v-if=" (this.sitetype==='1' || this.sitetype==='3' || this.sitetype==='4') && this.power==='1' ">
                  <td>
                        <el-form-item :label="$t('msg.파워볼일반')" class="mb-0 formItem" prop="event_loing_recom">
                          <el-input v-model="form.event_loing_recom"></el-input>
                        </el-form-item>
                  </td>
                  <td>
                  
                   <el-form-item :label="$t('msg.파워볼조합')" class="mb-0 formItem" prop="event_loing_group_recom">
                      <el-input v-model="form.event_loing_group_recom"></el-input>
                    </el-form-item>
                 
                  </td>
                </tr>
                <tr  v-if="this.sitetype==='4'">
                  <td>
                       <el-form-item :label="$t('msg.카지노롤링')" class="mb-0 formItem" prop="event_loing_recom_e">
                          <el-input v-model="form.event_loing_recom_e"></el-input>
                        </el-form-item>
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.슬롯롤링')" class="mb-0 formItem" prop="event_loing_recom_slot">
                        <el-input v-model="form.event_loing_recom_slot"></el-input>
                      </el-form-item>
                  </td>
                </tr>

                 <template v-if="this.sitetype==='4' && this.rosing==='1'">
                <tr>
                  <td colspan="2">
                     <div class="d-flex" style="margin-top:0.5rem">
                     <el-form-item :label="$t('msg.바카라루징')" prop="pc_e" class="mb-0 bl">
                        <el-input v-model="form.pc_e"></el-input>
                      </el-form-item>
                       <el-form-item :label="$t('msg.슬롯루징')" prop="pc_slot" class="mb-0 bc">
                      <el-input v-model="form.pc_slot"></el-input>
                    </el-form-item>
                     <el-form-item :label="$t('newAdd.파루징')" v-if="this.power==='1'" prop="pc_p" class="mb-0 bc-ml ">
                      <el-input v-model="form.pc_p"></el-input>
                    </el-form-item>
                    </div>

                  </td>
                </tr>
              </template>


                
                 <tr>
                  <td>
                    <el-form-item :label="$t('tableText.은행명')" class="mb-0 formItem">
                      <el-input v-model="form.mem_bankcode"></el-input>
                    </el-form-item>
                         
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.계좌번호')" class="mb-0 formItem">
                          <el-input v-model="form.mem_banknum"></el-input>
                        </el-form-item>
                   
                  </td>
                </tr>
                 <tr>
                  <td>  
                    <el-form-item :label="$t('tableText.예금주')" class="mb-0 formItem" prop="mem_bankname">
                        <el-input v-model="form.mem_bankname"></el-input>
                      </el-form-item>
                      
                  </td>
                  <td>
                     <el-form-item :label="$t('tableText.출금비번')" class="mb-0 formItem" :prop="editIndex===-1 ? 'mem_jumin' :'empty'">
                          <el-input v-model="form.mem_jumin"></el-input>
                        </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="출생년월" class="mb-0 formItem" prop="mem_zip">
                      <el-date-picker
                        v-model="form.mem_zip"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :default-value="birthDateDefault"
                        placeholder="YYYY-MM-DD"
                        class="w-75 birth-date-picker">
                      </el-date-picker>
                    </el-form-item>
                  </td>
                  <td></td>
                </tr>
               

  </table>
          </el-form>
         <div class="d-flex mt-2" style="justify-content:center">
              <el-button @click="shopClose">{{$t('msg.취소')}}</el-button> 
            <el-button type="primary" @click="submit" :disabled="disabled">{{$t('msg.확인')}}</el-button>
         </div> 
     
  </div>
</template>
<script>
 
  export default{
     components: {
     
      
    
    },
    props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       layerid:{
        type:String,
        default:""
      },
      
    },
    computed: {
          
          
            
        },
      data(){
        return{
            reLoading:false,
           boss_event_loing_recom_e:'',
           boss_event_loing_recom_slot:'',
           activeIndex: 'tab1',
           tapId:'0',
           tabname:'',
            bonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            ],
            bubonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            ],
            zplist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            ],
            disabled:false,
            birthDateDefault:new Date(1990, 0, 1),
          form:{
            cash_b:0,
             pc:'',
             pc_e:'',
              pc_p:'',
            pc_slot:'',
            recy:'0',
            shop_name:'',
             boss:'',
            reg_code:'',
            mem_pw:'',
            mem_name:'',
            mem_id:'',
             id:'',
            event_loing_recom:'',
            event_loing_recom_s:'',
            event_loing_group_recom:'',
             event_loing_recom_e:'',
            event_loing_recom_slot:'',
              mem_banknum:'',
            mem_bankcode:'',
            mem_bankname:'',
            mem_jumin:'',
            mem_zip:'',
            mem_hp:'',
           
            status:'1',
          },
           bubonOptlist:[{
                label:this.$i18n.t("msg.정상"),
                value:'1'
            },
            {
                label:this.$i18n.t("msg.차단"),
                value:'0'
            }
            
            ],
            zerocclist:[
            {
              label: this.$i18n.t("newAdd.없음"),
              value: '0',
            },
             {
              label: "하나",
              value: '1',
            }, {
              label: "두개",
              value: '2',
            }
            ],
          zerocc:'0',
          pi:false,
          editIndex:-1,
           mins:'1',
          maxs:'30',
          back_id:'',
          boss:'',
          tips:'',
          newDate:'',
          v:'',
           domain:window.sessionStorage.getItem('domain'),
           admin_id:window.sessionStorage.getItem('admin_id'),
           power:window.sessionStorage.getItem('power'),
            sitetype:window.sessionStorage.getItem('sitetype'),
            rosing:window.sessionStorage.getItem('rosing'),
            loading:false,
              rules: {
                  mem_jumin:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_e:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_slot:[{ required: true, message: '', trigger: 'blur'}],
                   recy:[{ required: true, message: '', trigger: 'blur'}],
                  shop_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankname:[{ required: true, message: '', trigger: 'blur'}],
                  reg_code:[{ required: true, message: '', trigger: 'blur'}],
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  mem_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_pw:[{ required: true, message: '', trigger: 'blur'}],
                  boss:[{ required: true, message: '', trigger: 'blur'}],
                  pc_slot:[{ required: true, message: '', trigger: 'blur'}],
                  pc_e:[{ required: true, message: '', trigger: 'blur'}],
                },
              
         
           
           
           
          
        }
      },
      created() {
         // this.info.id父组件传给子组件的id值
        
          this.fetchManage();
          this.form.boss = this.info.id
          this.boss_event_loing_recom_e = this.formatRate(this.info.event_loing_recom_e)
          this.boss_event_loing_recom_slot = this.formatRate(this.info.event_loing_recom_slot)
          this.form.event_loing_recom_e = this.boss_event_loing_recom_e
          this.form.event_loing_recom_slot = this.boss_event_loing_recom_slot
        

          
             
    },
    
      methods:{
        formatRate(value){
             if(value === '' || value === null || value === undefined) return ''
             const rate = Number(value)
             return Number.isNaN(rate) ? value : String(rate)
        },
        
        submit(){
             
             
              this.$refs.form.validate((e)=>{
                 if(!e) return;
           
             
                 this.disabled = true
               
                 
                 
                    this.loading =true
                    let token=window.sessionStorage.getItem('user');
                    this.$axios({
                        method:'post',
                        url:this.domain+'/user/pt_insert',
                        data:{
                         shop_name:this.form.shop_name,
                         boss:this.form.boss,
                          cash_b:this.form.cash_b,
                          reg_code:this.form.reg_code,
                          mem_pw:this.form.mem_pw,
                          mem_name:this.form.mem_name,
                          id:this.form.idx,
                          mem_id:this.form.mem_id,
                          event_loing_recom:this.form.event_loing_recom,
                          event_loing_recom_s:this.form.event_loing_recom_s,
                          event_loing_recom_e:this.form.event_loing_recom_e,
                          event_loing_recom_slot:this.form.event_loing_recom_slot,
                          mem_banknum:this.form.mem_banknum,
                          mem_bankcode:this.form.mem_bankcode,
                          mem_bankname:this.form.mem_bankname,
                          mem_jumin:this.form.mem_jumin,
                          mem_zip:this.form.mem_zip,
                          mem_hp:this.form.mem_hp,
                          event_loing_group_recom:this.form.event_loing_group_recom,
                          status:this.form.status,
                           recy:this.form.recy,
                          pc_slot:this.form.pc_slot,
                          pc_e:this.form.pc_e,
                          pc_p:this.form.pc_p,
                          pc:this.form.pc,
                           pi:this.pi,
                          mins:this.mins,
                          maxs:this.maxs,
                          zerocc:this.zerocc
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                            message:response.data.msg,
                            type: 'success'
                          });
                               //console.log(this.form);
                               this.$parent.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                              
                              this.$layer.close(this.layerid)

                            }
                           this.loading =false
                           this.disabled = false
                     
                  }).catch((error) =>{

                  })
            
            })
              
            
        },
        reConfirm(){
               let token=window.sessionStorage.getItem('user');

               if(this.form.mem_id=='')
               {
                    this.$message.error('id error')
                    return;
               }
               this.reLoading = true
               this.$axios({
                    method:'post',
                    url:this.domain+'/user/id_check',
                    data:{
                       mem_id:this.form.mem_id,
                        pi:this.pi,
                          mins:this.mins,
                          maxs:this.maxs,
                          zerocc:this.zerocc
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                    this.reLoading = false
                   console.log()
                   if(response.data.code==200)
                      {
                         this.$message({
                          message:response.data.msg,
                          type: 'success'
                        });

                         
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
         openShopModel(id){

          if(id=='합계')
          {
             return;
          }

           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: shopDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            success: function(layero, index) {
              //对加载后的iframe进行宽高度自适应
                //layer.iframeAuto(index);
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['1100px','600px'],
           
        });
        
        },

    
        fetchManage(){
        
          let token=window.sessionStorage.getItem('user');
 this.zplist=[]
return;
           this.$axios({
                  method:'get',
                  url:this.domain+'/user/zplist_select',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                 

                 let newids=[];


           response.data.data.forEach(item=>{
            let obj={};
            obj.label=item.code+'('+item.agent_name+')'
            obj.value=item.code
    
            newids.push(obj);

           
           });

            console.log('newidsnewids',newids);


                this.zplist=newids

                 
                  
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })

         


            this.form = {
                  cash_b:0,
                  recy:'0',
                  pc_slot:'',
                  pc_e:'',
                  pc_p:'',
                   pc:'',
                  shop_name:'',
                  reg_code:'',
                  boss:'',
                  mem_pw:'',
                  mem_name:'',
                  mem_id:'',
                  event_loing_group_recom:'',
                  event_loing_recom:'',
                  event_loing_recom_s:'',
                  event_loing_recom_e:'',
                  event_loing_recom_slot:'',
                  mem_banknum:'',
                  mem_bankcode:'',
                  mem_bankname:'',
                  mem_jumin:'',
                  mem_zip:'',
                  mem_hp:'',
                  status:'1'
                  

                 }



           

            //这里调用select接口

            
             this.editIndex = -1

          
           
          

        },
      
      searchEvent(){
        this.fetchManage()
      },
      shopClose(){
         this.$layer.close(this.layerid);
      },

      }
  }
</script>
<style scoped>

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }

/deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .birth-date-picker .el-input__prefix{
  display:none;
 }
 /deep/ .birth-date-picker .el-input__inner{
  padding-left:15px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 >>>.el-textarea__inner{
  height:33px;
 }
 >>>.el-tabs--border-card>.el-tabs__content{
  padding:5px;
 }
 .table{
  margin-bottom:5px;
 }
</style>



// WEBPACK FOOTER //
// src/components/common/shop-add.vue